// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__jAZXe","methods":"styles_methods__3B7wi","checkboxes":"styles_checkboxes__1FvQz","item":"styles_item__6mxNY","label":"styles_label__2oUCf"};